
import CaptchaProvider from "../providers/captcha-provider";
import TokenProvider from "../../commons/providers/token-provider";

class CaptchaRepository {
    
    constructor() {
        this.captchaProvider = new CaptchaProvider();
        this.tokenProvider = new TokenProvider();
    }

    postCaptcha = async (token) => {
        await this.tokenProvider.getToken();
        return this.captchaProvider.postCaptcha(token);
    }

}

export default CaptchaRepository;